import { MaterialIcon } from '../components/icon/icons';
import { Table } from '../components/table/table';
import { T, Translate } from '../i18n';
import type { MithrilVNode } from '../mithril';
import { FormList } from '../modules/form/form.list';
import { Services } from '../services';
import { AppStore } from '../store/index';
import { IkePage, type IkePageConfig, IkePageName } from './page';

export const FormListPageConfig: IkePageConfig = {
	type: 'internal',
	name: IkePageName.formList,
	path: '/form/list',
	auth: {
		required: true,
	},
	nav: {
		name: T.LIST_FORM_LIST,
		icon: MaterialIcon.CONTENT_PASTE,
	},
};

export class FormListPage extends IkePage {
	private component: FormList;

	constructor() {
		super(FormListPageConfig);

		this.component = new FormList();

		AppStore.FormSummary.refresh();
	}

	get nodes(): MithrilVNode {
		if (Services.Department.current == null) {
			return null;
		}

		if (!Services.User.current?.objectId) {
			return null;
		}

		const userProfile = Services.UserProfile.get(Services.User.current?.objectId);
		if (!userProfile) {
			return null;
		}

		if (!Services.UserProfile.canEditForms(userProfile)) {
			return Table.view(Translate(T.EXPORT_MENU_TITLE_PERMISSION), [], []);
		}

		return this.component.view();
	}
}
